import React from "react";
import { Row, Col, Button } from "antd";

const YesNoInput: React.FC<any> = ({
  value = undefined,
  placeholder,
  onChange,
}) => {
  return (
    <div className="tiles padding-12">
      <span className="col-label">{placeholder}</span>
      <Row className="mt-3 w-100">
        <Col span={24}>
          <Row className="d-flex">
            <Col span={12} className="pr-2">
              <Button
                className={`beam-btn cover w-full ${
                  value === "Yes" ? "btn-selected green" : ""
                }`}
                onClick={() => {
                  onChange("Yes");
                }}
              >
                Yes
              </Button>
            </Col>
            <Col span={12} className="pl-2">
              <Button
                className={`beam-btn cover w-full ${
                  value === "No" ? "btn-selected red" : ""
                }`}
                onClick={() => {
                  onChange("No");
                }}
              >
                No
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default YesNoInput;
